import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const HeartParticles = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const particleCount = window.innerWidth < 768 ? 6 : 10;
    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      emoji: Math.random() > 0.3 ? '❤️' : '💕',
      x: Math.random() * 100,
      size: Math.random() * 12 + 8,
      duration: Math.random() * 2 + 2,
      delay: i * 0.2
    }));

    setParticles(newParticles);

    const cleanup = setTimeout(() => {
      setParticles([]);
    }, 4000);

    return () => clearTimeout(cleanup);
  }, []);

  return (
    <div className="hearts-container">
      <p className="absolute bottom-1 right-2 z-20 text-[10px] text-gray-400 dark:text-gray-500">
        Updated: <time dateTime="2026-05-01">May 1, 2026</time>
      </p>
      <AnimatePresence>
        {particles.map((particle) => (
          <motion.div
            key={particle.id}
            className="heart-particle"
            style={{
              left: `${particle.x}%`,
              fontSize: `${particle.size}px`,
              bottom: '0'
            }}
            initial={{ 
              y: 0, 
              opacity: 0.7,
              scale: 0.5
            }}
            animate={{ 
              y: -60, 
              opacity: 0,
              scale: 1
            }}
            exit={{ opacity: 0 }}
            transition={{
              duration: particle.duration,
              delay: particle.delay,
              ease: "easeOut"
            }}
          >
            {particle.emoji}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default HeartParticles;